import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { MenuNavigationService } from 'app/services/menu-navigation.service';

@Component({
  selector: 'app-section-buttons',
  templateUrl: './section-buttons.component.html',
  styleUrls: ['./section-buttons.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, TranslateModule]
})
export class SectionButtonsComponent {
  @Input() protected from = '';
  @Input() protected selectedType;
  @Output() selectedTypeChange = new EventEmitter<object>();

  constructor(
    protected menuNavigationService: MenuNavigationService
  ) {}

  public viewPI() {
    this.menuNavigationService.viewProductPI();
  }

  public viewReferences() {
    this.selectedTypeChange.emit();
  }
}
